import React from "react";
import _ from "lodash";
import CTJoiningPlayerList from "../components/CTJoiningPlayerList";
import singleEye from "assets/images/ct/single-eye.png";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants, fadeVariants } from "shared/components/animations";
const CTjoining = ({ users,screens }) => {


  const info = _.get(
    screens,
    "1_lobby.info",
    "The truth can't hide forever."
  );
  const waiting_to_start = _.get(
    screens,
    "1_lobby.waiting_to_start",
    "Waiting to start."
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="ct-joining"
    >
      <motion.div variants={fadeVariants} className="text-center">
        <img src={singleEye} className="img-fluid eye-img" alt="" />
        <h2 className="title">{waiting_to_start}</h2>
        <p className="text">{info}</p>
      </motion.div>
      <CTJoiningPlayerList users={users} />
    </motion.div>
  );
};

export default CTjoining;
